/**
 * Audit Explorer
 *
 * Read-only explorer for browsing audit log entries.
 * Admin-only — accessed from Admin menu.
 *
 * Filters are managed by CBE's built-in filter system (quickFilters).
 */
import React from 'react';
import { useFusionAuth } from '@fusionauth/react-sdk';
import ConfigurableBaseExplorer from '../baseExplorer/ConfigurableBaseExplorer';
import ContextHelp from '../../../easymap/ContextHelp/ContextHelp';
import auditExplorerConfig from './AuditExplorerConfig';
import './AuditExplorer.scss';

interface AuditExplorerProps {
  className?: string;
  initialPosition?: { x: number; y: number };
  initialSize?: { width: number; height: number };
  onClose?: () => void;
}

const AuditExplorer: React.FC<AuditExplorerProps> = ({
  className,
  initialPosition = { x: 350, y: 150 },
  initialSize = { width: 1200, height: 700 },
  onClose,
}) => {
  const { isLoggedIn } = useFusionAuth();

  // ConfigurableBaseExplorer renders its own Export CSV button via the
  // config.export block. Keep this toolbar just for the help icon.
  const toolbar = (
    <div className="audit-filter-actions">
      <ContextHelp title='Help with Audit Log' context='audit-log-help' />
    </div>
  );

  return (
    <div className={`audit-explorer ${className || ''}`}>
      <ConfigurableBaseExplorer<any>
        config={auditExplorerConfig}
        isAuthenticated={isLoggedIn}
        isWindowed={true}
        windowTitle="Audit Log"
        initialPosition={initialPosition}
        initialSize={initialSize}
        resizable={true}
        draggable={true}
        showCloseButton={true}
        showMinimizeButton={true}
        onWindowClose={onClose}
        className="audit-explorer-configured"
        customToolbar={toolbar}
      />
    </div>
  );
};

export default AuditExplorer;
